import {
  SHChip,
  SHImage,
  SHStack,
  SHTypography,
} from "@components/design-systems";
import { SelectedProductDTO } from "@models/platform-analysis/entities/steps/feature";
import { Collapse } from "@mui/material";
import { toSentence } from "@utils";
import { isNil } from "lodash";
import { memo } from "react";
import { getProductRecommendationConfigs } from "../../../../utils";

interface SummaryAnalysisTableProductHeaderCellProps {
  product: SelectedProductDTO;
  fixedWidth?: number | string;
  isReview?: boolean;
}
export const SummaryAnalysisTableProductHeaderCell = memo(
  ({
    product,
    isReview,
    fixedWidth,
  }: SummaryAnalysisTableProductHeaderCellProps) => {
    const renderRecommendationLabel = () => {
      if (!isReview) return null;

      const { recommendation } = product;
      const { backgroundColor, icon, label, isCustomType } =
        getProductRecommendationConfigs(recommendation);

      return (
        <Collapse
          in={!isNil(label)}
          sx={{
            marginTop: 1,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SHStack
            height={20}
            bgcolor={backgroundColor || "transparent"}
            width={"100%"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <SHStack
              height={20}
              direction={"row"}
              alignItems={"center"}
              gap={0.5}
              justifyContent={"center"}
            >
              {icon}
              <SHTypography
                variant="body3"
                colorVariant="white"
                fontSize="12px"
                sx={{ paddingTop: 0.5 }}
              >
                {isCustomType ? label : toSentence(label)}
              </SHTypography>
            </SHStack>
          </SHStack>
        </Collapse>
      );
    };

    return (
      <SHStack
        width={fixedWidth || "auto"}
        maxWidth={fixedWidth || "auto"}
        direction={"column"}
        alignItems={"start"}
        justifyContent={"center"}
        position={"relative"}
        paddingTop={"10px"}
        paddingBottom={!isReview ? "10px" : 0}
        height={"100%"}
        minHeight={0}
        display={"flex"}
      >
        <SHStack
          width={"100%"}
          direction={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={"15px"}
          flexGrow={1}
        >
          {product.isProductMain && (
            <SHChip
              size="small"
              label={!isReview ? "Main" : "Current"}
              color={"warning"}
              variant={"outlined"}
              sx={{
                position: "absolute",
                zIndex: 1,
                top: 5,
                right: 5,
              }}
            />
          )}

          <SHStack
            direction={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={"5px"}
          >
            <SHImage src={product?.productLogo?.url} width={68} height={68} />
            <SHTypography
              variant="subtitle1"
              textAlign={"center"}
              addPaddingTop={false}
              fontWeight={700}
              fontSize={15}
              lineHeight={1.2}
              paddingX={"2px"}
            >
              {product?.productName}
            </SHTypography>

            {product?.subProductName && (
              <SHTypography
                addPaddingTop={false}
                variant="subtitle1"
                textAlign={"center"}
                fontWeight={700}
                fontSize={15}
                lineHeight={1.2}
              >
                {product?.subProductName}
              </SHTypography>
            )}
          </SHStack>
        </SHStack>

        {renderRecommendationLabel()}
      </SHStack>
    );
  },
);
